/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Ivetta Tkachenko <ivetta.tkachenko@opensoftdev.ru>
 */

define(['backbone', 'assets/js/modules/utils'], function(backbone, utils) {
    return backbone.Model.extend({
        defaults: {
            /** @var {OptionValueModel} option */
            optionValue: null,
            price: 0,
            salePrice: 0,
            enabled: true,
            visible: true,
            selected: false,
            vatRate: null
        },

        /**
         * @param {PricingCalcSkuModel} pricingCalcSku
         * @param {PricingCalcOptionValueModel[]} selectedOptionValues
         * @param {string} pricingSetName
         * @param {boolean} isNonBookletSubstrate
         * @param {boolean} withVat
         * @returns {number}
         */
        getPrice: function(pricingCalcSku, selectedOptionValues, pricingSetName, isNonBookletSubstrate, withVat) {
            var pricing = this.get('optionValue').get('pricing');

            let price = pricing.getPrice({
                sku: pricingCalcSku.get('sku'),
                quantity: pricingCalcSku.get('sku').get('quantity'),
                selectedOptionValues: selectedOptionValues,
                pricingSetName: pricingSetName,
                isNonBookletSubstrate: isNonBookletSubstrate,
                currentOptionValue: this.get('optionValue')
            });

            if (!withVat || this.get('vatRate') === null || isNaN(this.get('vatRate')) || isNaN(parseFloat(price))) {
                return price;
            }

            return utils.roundFloat(price + price * this.get('vatRate') / 100, 2);
        },

        /**
         * @param {boolean} [withVat]
         * @returns {number}
         */
        getCurrentPrice: function(withVat) {
            const price = this.get('price');

            return withVat ? utils.applyVat(price, this.get('vatRate')) : price;
        },

        /**
         * @param {boolean} [withVat]
         * @returns {number}
         */
        getCurrentSalePrice: function(withVat) {
            const price = this.get('salePrice');

            return withVat ? utils.applyVat(price, this.get('vatRate')) : price;
        }
    });
});
